import { useShallow } from 'zustand/shallow';
import { useGcsStore } from '../../../store/useGcsStore';
import { useFleetVisibilityStore as useSelectsFleetVisibility } from '../../../store/useFleetVisibilityStore';
import { selectIsVehicleUnderMyControl } from '../../../store/selectors/selectIsVehicleUnderMyControl';
import { selectVehicleStatusCategory } from '../../../store/selectors/selectVehicleStatusCategory';
import { VehicleStatusCategory } from '../../../types/ui/vehicleStatusCategory';
import SegmentedControl from '../../../components/general/SegmentedControl';
import { en } from '../../../locales/en';

const MAX_VEHICLES_PER_RPIC = 20;

function FleetVisibilitySegmentedControl() {
  const { visibility, setVisibility } = useSelectsFleetVisibility();

  const { allInflightCount, myInflightCount } = useGcsStore(
    useShallow((state) => {
      let allCount = 0;
      let myCount = 0;
      state.data.forEach((gcsData, gcsId) => {
        gcsData.vehicles.data?.forEach((vehicle) => {
          const category = selectVehicleStatusCategory(state.data, gcsId, vehicle.id);
          if (
            category === VehicleStatusCategory.INFLIGHT_NOMINAL ||
            category === VehicleStatusCategory.INFLIGHT_FAILURE_MODE
          ) {
            allCount++;
            if (selectIsVehicleUnderMyControl(state.data, gcsId, vehicle.id)) {
              myCount++;
            }
          }
        });
      });
      return { allInflightCount: allCount, myInflightCount: myCount };
    })
  );

  return (
    <SegmentedControl
      options={[
        {
          label: `${en.sidePanel.myVehicles} (${en.sidePanel.inflightCount.replace('{count}', String(myInflightCount))})`,
          value: 'mine',
          labelColor: myInflightCount > MAX_VEHICLES_PER_RPIC ? 'var(--color-danger)' : undefined
        },
        {
          label: `${en.sidePanel.allVehicles} (${en.sidePanel.inflightCount.replace('{count}', String(allInflightCount))})`,
          value: 'all'
        }
      ]}
      selectedValue={visibility}
      onValueChange={setVisibility}
    />
  );
}

export default FleetVisibilitySegmentedControl;
